import React from 'react'
import { EditDashboards } from '../../toolympus/components/EditDashboards/EditDashboards'
import { useEditDash } from '../../toolympus/components/EditDashboards/useEditDash'

export const EditDashboardsContainer = () => {
    return <EditDashboards data={useEditDash()} />
}